import { IDocumentReference, ICollectionReference } from '../database-cast/IDatabase';


export class DbObjectBase<T> {


    protected _docReference: IDocumentReference;
    private _id: string;


    constructor(id: string, collection: ICollectionReference) {


        this._docReference = collection.doc(id);
        this._id = id;


    }

    public getData(): Promise<T> {

        let promise: Promise<T> = new Promise((resolve, reject) => {
            this._docReference.get()
                .then(snapshot => {

                    let data = snapshot.data();
                    if (data != null) {
                        let obj = Object.assign(data);

                        obj.id = snapshot.id;
                        resolve(obj);
                    }
                    else {
                        resolve(null);
                    }
                })
                .catch(error => {
                    reject(error);
                })
        }
        );

        return promise;

    }

    public getDocument(): IDocumentReference {
        return this._docReference;
    }
    public update(object: T): Promise<T> {
        let promise = new Promise<T>((resolve, reject) => {

            let jsonObject = JSON.parse(JSON.stringify(object));


            this._docReference
                .set(jsonObject)
                .then(() => {
                    resolve(jsonObject);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return promise;
    }

    public updateFields(object: any): Promise<any> {
        let promise = new Promise<any>((resolve, reject) => {

            let jsonObject = JSON.parse(JSON.stringify(object));

            this._docReference
                .setFields(jsonObject)
                .then(() => {
                    resolve(jsonObject);
                })
                .catch(error => {
                    reject(error);
                });
        });

        return promise;
    }


    public delete(): Promise<void> {



        return this._docReference.delete();

        // let promise = new Promise<T>((resolve, reject) => {

        //     this._docReference
        //         .set(Object.assign({}, filter))
        //         .then(() => {
        //             resolve(filter);
        //         })
        //         .catch(error => {
        //             reject(error);
        //         });
        // });

        // return promise;
    }
}

